$(".search-popup__trigger").on("click", function(e) {
  e.preventDefault();
  $(".backplate").addClass("backplate--open backplate--over");
  $(".o-popup--search").addClass("o-popup--open");
});

$(".backplate,.o-popup__close").on("click", function() {
  $(".o-popup--search").removeClass("o-popup--open");
  $(".backplate").removeClass("backplate--open backplate--over");
});
